export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
  NUMBER = 'number',
  TEL = 'tel',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  TEXTAREA = 'textarea',
  SIGNATURE = 'signature',
  RADIO_MULTIPLE = 'radioMultiple',
  CHECK_MULTIPLE = 'checkMultiple',
  DATE = 'date',
  FILE = 'file',
}

export interface SelectOption {
  label: string;
  value: string;
}
